import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=6b8fa338&"
import script from "./batch.vue?vue&type=script&lang=js&"
export * from "./batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports